<template>
  <div class="zszy_h5">
      <TopTabs :list="this.$nav6"/>
      <div class="specialty">
        <ul class="web_major_list">
          <li class="web_major_listItem"
              v-for="(item, index) in list" :key="index"
              @click="toPage(item)">
             {{item.name}}
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'
export default {
  name: 'xyjjH5',
  components: { TopTabs },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {

      isMaxScreen: true
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  methods: {
    toPage (item) {
      this.$router.push({ path: '/zszy/zyjj?ids=0', query: { id: item.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
   .specialty {
    min-height: 86.5vh;
  }
  .web_major_list {
      width: 100%;
      padding: 0 4.2667vw;
      .web_major_listItem {
        width: 100%;
        line-height: 15.5333vw;
        font-size: 3.7333vw;
        border-bottom: 0.1333vw dashed #DEDEDE;
        cursor: pointer;

      }
      .web_major_listItem::before {
        content: '';
        display: inline-block;
        width: 1.6vw;
        height: 1.6vw;
        background: #FF8660;
        margin-right: 1.8667vw;
        border-radius: 50%;
        margin-bottom: 0.5333vw;

      }
      .nomargin {
         margin-left: 0;
      }
    }
</style>
